export const actionTypes = {
  CREATE: 'create',
  SET: 'set',
  VIEW: 'view',
  CLOSE: ''
};

export const filterTypes = {
  YEAR: 'year',
  MONTHS: 'months',
  LOCATIONS: 'locations',
  STATUS: 'status',
  DAY: 'day',
  SORTBY: 'sortby'
};
